// extracted by mini-css-extract-plugin
export default {"summary":"NutrientSummary_summary__89uld","nutrient":"NutrientSummary_nutrient__xT3r3","value":"NutrientSummary_value__gHVw0","label":"NutrientSummary_label__5nxx7"};